<script>
	import { assetUrl } from 'utilities/urlUtilities';

	export default {
		data() {
			return {
				awards: [
					{
						imgSrc: '/assets/dist/images/awards/charity-navigator-4-star.png',
						tag: 'CHARITY_NAVIGATOR_AWARD',
						alt: 'Charity Navigator Award - Four Star',
						url: 'https://www.charitynavigator.org/ein/133593812'
					},
					{
						imgSrc: '/assets/dist/images/awards/candid-seal-platinum-2024.png',
						tag: 'GUIDESTAR_PLATINUM_2024_AWARD',
						alt: 'Guidestar Platinum Transparency Award 2024, Candid',
						url: 'https://www.guidestar.org/profile/13-3593812'
					},
					{
						imgSrc: '/assets/dist/images/awards/loc_literacy_honoree_2022.jpg',
						tag: 'LOC_LITERACY_HONOREE_2022',
						alt: 'Library of Congress Literacy Award Winner 2022 - Success Practices Honoree ',
						url: 'https://www.loc.gov/programs/library-of-congress-literacy-awards/winners-and-honorees/winners/2022-winners-and-honorees/'
					},
					{
						imgSrc: '/assets/dist/images/awards/digital_promise_cert_sm.png',
						tag: 'DIGITAL_PROMISE_CERTIFICATION',
						alt: 'Digital Promise Product Certification',
						url: 'https://productcertifications.digitalpromise.org/learner-variability-certified-products/'
					},
					{
						imgSrc: '/assets/dist/images/awards/digital_promise_essa_tier_3.png',
						tag: 'DIGITAL_PROMISE_CERTIFICATION_EVIDENCE_BASED',
						alt: 'Evidence-Based EdTech ESSA Tier 3 Product Certificate Issued By Digital Promise',
						url: 'https://www.abc27.com/business/press-releases/cision/20240417NY89144/readworks-awarded-evidence-based-edtech-essa-tier-3-product-certification/'
					},
					{
						imgSrc: '/assets/dist/images/awards/digital_promise_practitioner_informed_design.png',
						tag: 'DIGITAL_PROMISE_INFORMED_DESIGN',
						alt: 'Practitioner Informed Design Product Certificate Issued By Digital Promise',
						url: 'https://digitalpromise.org/2024/01/23/how-do-you-find-edtech-tools-that-take-educator-expertise-seriously/'
					},
					{
						imgSrc: '/assets/dist/images/awards/cool-tool-finalist-2023.png',
						tag: 'COOL_TOOL_2023_AWARD',
						alt: 'The Edtech Awards - Cool Tool Finalist 2023',
						url: 'https://www.edtechdigest.com/2023-finalists-winners/'
					},
					{
						imgSrc: '/assets/dist/images/awards/spp_signatory.png',
						tag: 'SPP_SIGNATORY',
						alt: 'Student Privacy Pledge Signatory'
					},
					{
						imgSrc: '/assets/dist/images/awards/edsurge_product_index.png',
						tag: 'EDSURGE_PRODUCT_INDEX',
						alt: 'Find us on the EdSurge Product Index',
						url: 'https://index.edsurge.com/product/ultid/P77C-4331-1359-C443-89/'
					},
					{
						imgSrc: '/assets/dist/images/awards/graphite_top_pick.jpg',
						tag: 'GRAPHITE_TOP_PICK_AWARD',
						alt: 'Common Sense Graphite Top Pick',
						url: 'https://www.commonsense.org/education/top-picks/ela-products-aligned-to-common-core-standards'
					}
				]
			};
		},
		methods: {
			assetUrl(url) {
				return assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';

	.awards-list {
		margin: 1rem 0;
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		align-items: center;

		@include media(med) {
			justify-content: flex-start;
		}

		.award {
			margin: 0.5rem;
		}

		a {
			display: inline-block;
		}

		img {
			max-width: 100px;
			max-height: 100px;
		}
	}
</style>
<template>
	<ul
		aria-label="ReadWorks awards"
		class="awards-list list-unstyled">
		<li
			v-for="award in awards"
			:key="award.tag"
			class="award">
			<outbound-link
				v-if="award.url"
				class="award-link"
				:href="award.url"
				target="_blank"
				:data-outbound-link="award.tag">
				<img
					loading="lazy"
					:src="assetUrl(award.imgSrc)"
					:alt="award.alt" />
			</outbound-link>
			<img
				v-else
				loading="lazy"
				:src="assetUrl(award.imgSrc)"
				:alt="award.alt" />
		</li>
	</ul>
</template>
